import type { components } from '../../../generated/schema';
import { api } from '../api';

type Schemas = components['schemas'];

export interface ErrorLog {
  error: string;
  component_stack?: string;
  context?: Record<string, unknown>;
}

export type LoggingResponse = Schemas['LoggingResponse'];

/**
 * Log a message
 * @param error - the error to log
 * @param info - additional info to log
 */
export const logError = async (
  error: Error,
  info?: { componentStack: string; context?: Record<string, unknown> },
): Promise<LoggingResponse> => {
  const body: ErrorLog = {
    error: error.message,
    component_stack: info?.componentStack,
    context: info?.context,
  };
  return api.post('api/logging', { json: body }).json<LoggingResponse>();
};
